import React, { useEffect, useState } from "react";

const STAGE_BG = "https://static.prod-images.emergentagent.com/jobs/7da67566-14f0-421c-95de-419f063a84b7/images/0b975fea3e538b25b2d5f1a60cf96971d0d2e53a89a6320f6fa47abcf2182e36.png";

const PresentationOverlay = ({ singer, dedication, onSkip, mode = "inline" }) => {
  const [count, setCount] = useState(10);

  useEffect(() => {
    setCount(10);
    const timer = setInterval(() => setCount((c) => (c > 0 ? c - 1 : 0)), 1000);
    return () => clearInterval(timer);
  }, [singer]);

  const isFullscreen = mode === "fullscreen";
  const positioning = isFullscreen ? "fixed inset-0 z-50" : "absolute inset-0 z-30";
  const labelSize = isFullscreen ? "text-xs sm:text-sm" : "text-[10px] sm:text-xs";
  const headSize = isFullscreen
    ? "text-5xl sm:text-7xl md:text-8xl lg:text-9xl"
    : "text-3xl sm:text-5xl lg:text-6xl";
  const nameSize = isFullscreen
    ? "text-6xl sm:text-8xl md:text-9xl lg:text-[10rem]"
    : "text-5xl sm:text-7xl lg:text-8xl";
  const dedicationSize = isFullscreen ? "text-lg sm:text-2xl md:text-3xl" : "text-sm sm:text-base lg:text-lg";

  return (
    <div
      className={`${positioning} flex flex-col items-center justify-center overflow-hidden`}
      data-testid="presentation-overlay"
      onClick={onSkip}
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url('${STAGE_BG}')` }}
      />
      <div className="absolute inset-0 bg-black/85 backdrop-blur-md" />
      <div className="absolute inset-0 grain pointer-events-none" />

      <div className="relative z-10 text-center px-6 animate-presentation-in max-w-full">
        <p className={`text-secondary font-mono ${labelSize} tracking-[0.35em] uppercase mb-3 animate-slide-up`}>
          ▸ Próximo en el escenario
        </p>
        <h1 className={`font-display font-black uppercase tracking-tighter text-white animate-glow-pulse leading-[0.95] ${headSize}`}>
          ¡Es turno de
        </h1>
        <h2
          className={`font-display font-black uppercase tracking-tighter text-primary neon-pink animate-glow-pulse mt-1 break-words leading-[0.95] ${nameSize}`}
          data-testid="presentation-singer-name"
        >
          {singer}!
        </h2>

        {dedication && (
          <div className={`mt-${isFullscreen ? "6" : "3"} max-w-3xl mx-auto`}>
            <p className={`text-secondary/70 font-mono uppercase tracking-[0.3em] mb-1 ${isFullscreen ? "text-[10px] sm:text-xs" : "text-[9px]"}`}>
              ♥ Dedicado a
            </p>
            <p
              className={`font-display italic text-white/90 ${dedicationSize} leading-snug`}
              data-testid="presentation-dedication"
            >
              "{dedication}"
            </p>
          </div>
        )}

        <div className={`mt-${isFullscreen ? "8" : "4"} inline-flex items-center gap-3 text-muted-foreground font-mono ${
          isFullscreen ? "text-sm" : "text-[11px]"
        }`}>
          <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
          Comenzando en {count}s
          <span className="w-2 h-2 rounded-full bg-secondary animate-pulse" />
        </div>
        {!isFullscreen && (
          <p className="mt-3 text-[10px] text-muted-foreground/60 font-mono uppercase tracking-widest">
            Click para omitir
          </p>
        )}
      </div>
    </div>
  );
};

export default PresentationOverlay;
